
define('ldsh!modules/page_listing/templates/copy_to_account_popup', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-overlay-container">\n  <div class="md__modal__inner__container">\n    <div class="ed-opt-toolbar ed-modal-header">\n      <div class="ed-close-wrapper">\n        <i class="ri-close-line js-cancel" data-dismiss="modal"></i>\n      </div>\n      <h3\n        data-i18n="pageListing.dialog.copyToAccount.title"\n        class="ed-modal-title"\n      ></h3>\n    </div>\n\n    <div class="ed-opt-content ed-modal-content">\n      <p>\n        <span\n          data-i18n="pageListing.dialog.copyToAccount.message"\n        ></span>\n      </p>\n      <div class="ed-form-group">\n      <select class="ed-form-control one-half js-account-selector e100">\n        ';
 _.each(companies, function(company) { ;
__p += '\n          <option\n            value="' +
((__t = ( company.id )) == null ? '' : __t) +
'"\n            ' +
((__t = ( companyId === company.id ? 'selected' : '' )) == null ? '' : __t) +
'\n          >' +
((__t = ( company.name )) == null ? '' : __t) +
'</option>\n        ';
 }) ;
__p += '\n      </select>\n      </div>\n    </div>\n\n    <div class="ed-form-group"></div>\n\n    <div class="ed-opt-btnbar ed-modal-footer">\n      <button\n        data-i18n="pageListing.dialog.copyToAccount.cancelButton"\n        type="button"\n        class="ed-btn ed-btn-secondary-action js-cancel"\n        data-dismiss="modal"\n      ></button>\n      <button\n        data-i18n="pageListing.dialog.copyToAccount.okButton"\n        type="button"\n        class="ed-btn ed-btn-primary-action js-ok"\n      ></button>\n    </div>\n  </div>\n</div>\n';

}
return __p
};});

